// @ts-ignore
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export const ErrorPageMessage = 'Oh snap! Something went wrong.';

export const NoMatch = () => {
    return <ErrorState headline={ErrorPageMessage} />;
};
